<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header">
        <div class="new-input">
          <span class="tms">N</span>
          <input type="text" :placeholder="$t('search')" v-model="searchMechanizations" />
        </div>
        <span class="tms modal-close" @click="close()">F</span>
      </div>
      <div class="modal-content" v-if="!isCommingFromReport">
        <div
          v-if="!mechanizations.length"
          class="modal-content-template"
          @click="triggerFileInput()"
        >
          <img
            class="modal-content-template-img desktop"
            :src="getImg(false)"
            :alt="$t('table-structure')"
          />
          <img
            class="modal-content-template-img mobile"
            :src="getImg(true)"
            :alt="$t('table-structure')"
          />
        </div>
        <div
          class="modal-content-item"
          v-for="(mechanization, index) in filteredMechanizations"
          :key="`mechanizationModal-${index}-${mechanization.name}`"
          :title="mechanizations.name"
        >
          <p>{{mechanization.name}}</p>
          <span class="tms" @click="deleteMechanization(index)" title>b</span>
        </div>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="mechanizations.length && !filteredMechanizations.length"
        >
          {{ $t('no-results-for') }} '
          <strong>{{this.searchMechanizations}}</strong>'
        </p>
      </div>
      <div class="modal-content" v-else>
        <p
          v-if="!mechanizations.length"
          class="modal-content-no-results text-align-center"
        >{{ $t('no-mechanizations') }}</p>
        <div
          class="modal-content-item"
          v-for="(m, i) in filteredMechanizations"
          :key="`addMechanizations-${i}-${m._id}`"
          @click="saveSingle(m)"
          :title="m.name"
        >{{ m.name }}</div>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="mechanizations.length && !filteredMechanizations.length"
        >
          {{ $t('no-results-for') }} '
          <strong>{{this.searchMechanizations}}</strong>'
        </p>
      </div>
      <div class="modal-footer">
        <div class="btns-select" v-if="isCommingFromReport">
          <button class="btn btn-select" @click="isEditInputModalOpened = true">
            <span class="tms">L</span>
            {{ $t('new-mechanization') }}
          </button>
        </div>
        <div v-else>
          <!-- EMPTY DIV FOR THE SPACE-AROUND RULE TO WORK -->
        </div>
        <div class="btns">
          <button class="btn btn-excel" @click="triggerFileInput()" v-if="!isCommingFromReport">
            <span class="tms">E</span>
            {{ $t('new-file') }}
          </button>
          <input ref="uploadMechanizations" class="input-hide" type="file" @change="handleFile" />
          <!--  -->
          <button class="btn btn-new" @click="save()" v-if="!isCommingFromReport">
            <span class="tms">Y</span>
            {{ $t('save') }}
          </button>
        </div>
      </div>
    </div>
    <EditInputModal v-if="isEditInputModalOpened" :isComingFromMechanizations="true"></EditInputModal>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import EditInputModal from './EditInputModal';
export default {
  components: {
    EditInputModal
  },
  props: [
    'incomingMechanizations',
    'isCommingFromReport',
    'companyId',
    'objectId',
    'partId'
  ],
  watch: {
    incomingMechanizations() {
      this.initMechanizations();
    }
  },
  data() {
    return {
      isEditInputModalOpened: false,
      mechanizations: [],
      selectedIndex: undefined,
      searchMechanizations: ''
    };
  },
  computed: {
    filteredMechanizations() {
      return this.filterMechanizations();
    }
  },
  methods: {
    getImg(mobile) {
      return `${process.env.VUE_APP_STATIC_URI}/table_help${
        mobile ? '_mobile' : ''
      }_${this.$i18n.locale}.png`;
    },
    triggerFileInput() {
      this.$refs.uploadMechanizations.click();
    },
    // EXCEL FILE TO JSON
    handleFile(e) {
      let rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer
      const files = e.target.files;
      const f = files[0];
      if (f.name.match(`.(xls|XLS|xlsx|XLSX)$`)) {
        const reader = new FileReader();
        reader.onload = e => {
          let data = e.target.result;
          if (!rABS) data = new Uint8Array(data);
          const workbook = XLSX.read(data, { type: rABS ? 'binary' : 'array' });

          /* DO SOMETHING WITH workbook HERE */
          const rows = this.workbookToJSON(workbook);
          // SHEET
          for (let row in rows) {
            const keys = Object.keys(rows[row][0]);
            for (let i = 0; i < keys.length; i++) {
              if (
                !(
                  keys[i].toLowerCase().includes(this.$t('table-name')) ||
                  keys[i].toLowerCase().includes(this.$t('table-unit')) ||
                  keys[i].toLowerCase().includes(this.$t('table-price'))
                )
              ) {
                this.$snotify.error(this.$t('table-warning'));
                return;
              }
            }
            // ROW OBJECT
            for (let item in rows[row]) {
              // ROW DATA
              this.mechanizations.push({
                name: rows[row][item][Object.keys(rows[row][item])[0]].toString(),
                unit: rows[row][item][Object.keys(rows[row][item])[1]],
                price: rows[row][item][Object.keys(rows[row][item])[2]]
              });
            }
          }
        };
        if (rABS) reader.readAsBinaryString(f);
        else reader.readAsArrayBuffer(f);
      } else {
        this.$snotify.error(this.$t('table-warning-xls'));
      }
    },
    workbookToJSON(workbook) {
      var result = {};
      workbook.SheetNames.forEach(sheetName => {
        var roa = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        );
        if (roa.length > 0) {
          result[sheetName] = roa;
        }
      });
      return result;
    },
    filterMechanizations() {
      return this.mechanizations.filter(a => {
        return a.name
          .toLowerCase()
          .includes(this.searchMechanizations.toLowerCase());
      });
    },
    // Handle added mechanization from EditInput
    handleAdd(newMechanization) {
      // this.mechanizations.unshift(newMechanization);
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.companyId}`;
      this.$http
        .get(url)
        .then(response => {
          const company = response.data;
          // get index of selected project
          const indexOfObject = company.objects.findIndex(
            p => p._id === this.objectId
          );
          // get index of selected object
          const indexOfPart = company.objects[
            indexOfObject
          ].parts.findIndex(o => o._id === this.objectId);
          company.objects[indexOfObject].parts[
            indexOfPart
          ].mechanizations.push(newMechanization);

          // make the post request
          let url = `${process.env.VUE_APP_BASE_URI}/company/${company._id}`;

          this.$http
            .put(url, company)
            .then(() => {
              this.$snotify.success(this.$t('success-mechanization'));
              this.$parent.$emit('getMechanizationsAgain');
            })
            .catch(error => {
              console.log(error);
              this.$snotify.error(this.$t('something-went-wrong'));
            });
        })
        .catch(error => console.log(error));
    },
    deleteMechanization(i) {
      this.mechanizations.splice(i, 1);
    },
    getSelectedMechanizations() {
      return this.mechanizations.filter(a => {
        return a.isSelected;
      });
    },
    close() {
      this.$parent.$emit('closeAddMechanizationsModal');
    },
    saveSingle(m) {
      this.$parent.$emit('saveAddMechanizationsModal', {
        name: m.name.toString(),
        unit: m.unit,
        price: m.price
      });
    },
    save() {
      this.$parent.$emit('saveAddMechanizationsModal', this.mechanizations);
    },
    initMechanizations() {
      this.mechanizations = this.$cloneDeep(this.incomingMechanizations);

      this.mechanizations.sort((x, y) => {
        return x.isSelected === y.isSelected ? 0 : x.isSelected ? -1 : 1;
      });
    },
    closeEditInputModal() {
      this.isEditInputModalOpened = false;
    }
  },
  mounted() {
    this.initMechanizations();

    this.$on('saveMaterialActivityOrMechanization', this.handleAdd);
    this.$on('closeEditInputModal', this.closeEditInputModal);
    this.$eventBus.$on('closeModalFromSpeechRecognition', () => {
      this.close();
    });
  },
  destroyed() {
    this.$off('saveMaterialActivityOrMechanization');
    this.$off('closeEditInputModal');
    this.$eventBus.$off('closeModalFromSpeechRecognition');
  }
};
</script>

<style scoped>
.model-wrapper {
  justify-content: center;
}
/* .modal-header {
  background: #17643a;
} */
.desktop {
  display: initial;
}
.mobile {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    max-height: 90vh;
    overflow: unset;
    width: 90%;
  }
  .modal-content-item {
    height: fit-content;
    min-height: 55px;
    width: 100%;
  }
  .modal-content-check {
    margin-bottom: 5px;
    width: 100%;
  }
}
@media screen and (max-width: 700px) {
  .modal-footer {
    height: 98px;
    flex-direction: column;
  }
  .btn.btn-new {
    margin-bottom: 0.8em;
  }
  .btns-select {
    display: flex;
    justify-content: center;
    margin-top: 1em;
  }
  .btn-select {
    padding: 0 10px;
  }
}
@media screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: initial;
  }
  .modal-header .new-input {
    width: 60%;
  }
}
@media screen and (max-width: 500px) {
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-excel {
    margin-bottom: 0.5em;
  }
}
</style>
